import { ACCOUNT_TAB_APP_VIEW_IDS, canAccessAny, canAccessNavItem } from './canAccess';
import { getNavItemsForRegistry } from './viewRegistry';

const NAV_GROUP_ORDER = ['Company', 'Billing', 'General', 'Super Admin'];

function isCompanyApproved(userCompany) {
    return !!userCompany?.[0]
        && (userCompany[0].companyStatus == 1 || userCompany[0].companyStatus == 2);
}

function toNavItemDisplay(item) {
    return {
        href: item.href,
        title: item.title,
        icon: item.icon,
    };
}

function getPermissionFilteredNavItems(permissionState) {
    return getNavItemsForRegistry()
        .filter((item) => canAccessNavItem(item.appViewId, permissionState));
}

export function getMainNavItems(permissionState, userCompany) {
    return getAccessibleNavItems(permissionState, userCompany)
        .filter((item) => item.navGroup !== 'Super Admin' && item.navGroup !== 'General')
        .map(toNavItemDisplay);
}

export function getApprovedGeneralNavItems(permissionState, userCompany) {
    return getAccessibleNavItems(permissionState, userCompany)
        .filter((item) => item.navGroup === 'General')
        .map(toNavItemDisplay);
}

export function getGeneralNavItems(permissionState) {
    return getPermissionFilteredNavItems(permissionState)
        .filter((item) => item.navGroup === 'General')
        .map(toNavItemDisplay);
}

export function getSuperAdminNavItems(permissionState) {
    return getPermissionFilteredNavItems(permissionState)
        .filter((item) => item.navGroup === 'Super Admin')
        .map(toNavItemDisplay);
}

export function getAccessibleNavItems(permissionState, userCompany) {
    if (!permissionState?.loaded) {
        return [];
    }

    if (!isCompanyApproved(userCompany)) {
        return [];
    }

    return getNavItemsForRegistry()
        .filter((item) => canAccessNavItem(item.appViewId, permissionState))
        .sort((left, right) => {
            const leftIndex = NAV_GROUP_ORDER.indexOf(left.navGroup);
            const rightIndex = NAV_GROUP_ORDER.indexOf(right.navGroup);
            return leftIndex - rightIndex;
        });
}

export function getDefaultLandingRoute(permissionState, userCompany) {
    if (!permissionState?.loaded) {
        return null;
    }

    const accessibleNavItems = getAccessibleNavItems(permissionState, userCompany);
    const firstNavItem = accessibleNavItems.find((item) => item.href);
    if (firstNavItem?.href) {
        return firstNavItem.href;
    }

    return canAccessAny(ACCOUNT_TAB_APP_VIEW_IDS, permissionState) ? '/account' : null;
}
